import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-contracts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/sale-contracts/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/sale-contracts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/sale-contracts/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/v1/sale-contracts/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const toPdf = id => {
  return httpClient
    .get(`/api/v1/sale-contracts/${id}/to-pdf`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = () => {
    return httpClient
    .get('/api/v1/sale-contracts/products')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const customer = () => {
    return httpClient
    .get('/api/v1/sale-contracts/customers')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export const quotation = () => {
    return httpClient
    .get('/api/v1/sale-contracts/quotations')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data)) 
}

export default { 
    get, 
    find,
    store,
    update,
    destroy,
    product,
    customer,
    toPdf,
    quotation
}
